import { useState } from "react";

import { S3ImageImageProps } from "./S3Image";
import { S3ImageFullScreen } from "./S3ImageFullScreen";
import { allowedFileTypes, getFileExtensionFromSignedUrl } from "./fileHelper";
import VideoDialog from "./VideoDialog";
import Box from "@mui/material/Box";

interface MediaFullScreenProps {
  keyFrame?: string;
  mediaOutput?: string;
  s3ImageFullScreenProps?: Omit<S3ImageImageProps, "s3Key">;
  height?: number | string;
}

export const MediaFullScreen = ({
  keyFrame = "",
  mediaOutput = "",
  s3ImageFullScreenProps,
  height = 40,
}: MediaFullScreenProps) => {
  const [videoUrl, setVideoUrl] = useState("");

  const handleVideoUrl = (url: string) => () => {
    setVideoUrl(url);
  };

  const handleCloseVideo = () => {
    setVideoUrl("");
  };

  const mediaOutputExtension = getFileExtensionFromSignedUrl(mediaOutput);

  const isVideo = allowedFileTypes.videos.some(
    (allowedVideoExtension): boolean => {
      return allowedVideoExtension === mediaOutputExtension;
    }
  );

  return (
    <Box>
      {!!videoUrl && (
        <VideoDialog
          videoUrl={videoUrl}
          expanded={!!videoUrl}
          toggleExpand={handleCloseVideo}
        />
      )}

      <S3ImageFullScreen
        sx={{
          width: "100%",
          maxHeight: height,
          maxWidth: "120px",
          cursor: "pointer",
        }}
        deviceStatus={true}
        variant="image"
        s3Key={keyFrame}
        onClickVideoIcon={
          mediaOutput && isVideo ? handleVideoUrl(mediaOutput) : undefined
        }
        {...s3ImageFullScreenProps}
      />
    </Box>
  );
};
